<template>
  <Modal
    :id="id"
    :modalTitle="contractId + ' - ' + modalTitle"
    :class="classes"
    :onClose="onClose"
  >
    <div class="row">
      <div
        v-if="loading && error === ''"
        class="col-12"
        style="display: flex; justify-content: center; align-items: center"
      >
        <img
          src="../../../../../assets/loaderPrimary.svg"
          height="200"
          alt=""
        />
      </div>
      <template v-if="!loading && error !== ''">
        <div class="col-12 col-lg-12">
          <span class="generalTitleItemModal">Ha ocurrido un error:</span>
        </div>
        <div class="col-12 col-lg-12 mt-4">
          <span class="text-danger">{{ error }}</span>
        </div>
      </template>

      <template v-if="!loading && error === ''">
        <div class="col-12 col-lg-12" v-if="data.length > 0">
          <table class="table">
            <thead class="fixheader">
              <tr>
                <th scope="col" class="align-middle">Fecha</th>
                <th scope="col" class="align-middle">Importe</th>
                <th scope="col" class="align-middle">Tipo</th>
                <th scope="col" class="align-middle">Estado</th>
                <th class="align-middle thError">Error</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <td class="py-4 align-middle">
                  {{ $dateBackToFront(item.paymentDate, true) || "-" }}
                </td>
                <td class="py-4 align-middle">
                  {{ item.amount }} €
                </td>
                <td class="py-4 align-middle">
                  {{ item.type }}
                </td>
                <td class="py-4 align-middle">
                  {{ item.status }}
                </td>
                <td
                  class="py-4 align-middle tdError"
                  style="max-width: 100%"
                  :title="item.errorDescription || ''"
                >
                  <span v-if="item.errorCode || item.errorDescription" class="badge text-muted border border-dark">
                    {{ `${item.errorCode || ''}: ${item.errorDescription || ''}` }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 col-lg-12" v-if="data.length === 0">
          <template class="alert alert-warning" role="alert">
            No hay datos para mostrar
          </template>
        </div>
      </template>
    </div>
    <button
      :id="id + 'CierreModal'"
      style="display: none"
      data-dismiss="modal"
    />
  </Modal>
</template>

<script>
import axios from "axios";
import Modal from "../../../Shared/Modal.vue";
export default {
  name: "additionalChargesModal",
  props: ["id", "modalTitle", "class", "contractId"],
  data() {
    return {
      classes: this.class,
      loading: true,
      parameters: "",
      error: "",
      data: [],
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    Modal,
  },
  methods: {
    loadData() {
      axios
        .get(`/payment/${this.contractId}/immediate-payment`)
        .then((response) => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.response.data.message || error.response.data.error;
        });
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", "");
    },
  },
};
</script>

<style lang="scss"></style>
